import { render } from "./AnimationBar.vue?vue&type=template&id=2c4d571d"
import script from "./AnimationBar.vue?vue&type=script&lang=js"
export * from "./AnimationBar.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__